import { useCallback } from 'react';
import useAxios from '@Apis/useAxios';
import {
    GET_CLUBS_API,
    GET_CLUBS_OPTIONS_API,
    POST_CLUBS_OVERVIEW_API,
    GET_CLUBS_CLUBID_API,
    POST_CLUBS_API,
    PUT_CLUBS_CLUBID_API,
    POST_CLUBS_CLUBID_ENSURE_ACCOUNTS_API,
} from '@Apis/apiPath';

/** 店舖相關 API(對應後端 CV.Club) */
const useClubApi = () => {
    const Axios = useAxios();

    /** 舊端點保留(全量、無分頁)，前端店舖總覽頁不再使用，改用 postClubsOverviewApi */
    const getClubsOverviewApi = useCallback(
        async () => {
            return await Axios.get(GET_CLUBS_API);
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 取得店舖相關下拉式選單
     * @param {boolean} [skipAll=false] 是否略過店舖狀態的「全部」選項
     * @returns {Promise<{clubOptions: Array, clubStatusOptions: Array}>}
     */
    const getClubsOptionsApi = useCallback(
        async (skipAll = false) => {
            return await Axios.get(GET_CLUBS_OPTIONS_API, { skipAll });
        },
        // eslint-disable-next-line
        [],
    );

    /** 店舖總覽(伺服器端搜尋與分頁) */
    const postClubsOverviewApi = useCallback(
        async (params) => {
            return await Axios.post(POST_CLUBS_OVERVIEW_API, params);
        },
        // eslint-disable-next-line
        [],
    );

    const getClubApi = useCallback(
        async (clubID) => {
            return await Axios.get(GET_CLUBS_CLUBID_API(clubID));
        },
        // eslint-disable-next-line
        [],
    );

    const postClubApi = useCallback(
        async (params) => {
            return await Axios.post(POST_CLUBS_API, params);
        },
        // eslint-disable-next-line
        [],
    );

    const putClubApi = useCallback(
        async (clubID, params) => {
            return await Axios.put(PUT_CLUBS_CLUBID_API(clubID), params);
        },
        // eslint-disable-next-line
        [],
    );

    /**
     * 檢查/補建店舖固定帳號；selection 為 { common, owner, admin }，皆 bool。冪等。
     */
    const postEnsureAccountsApi = useCallback(
        async (clubID, selection) => {
            return await Axios.post(POST_CLUBS_CLUBID_ENSURE_ACCOUNTS_API(clubID), selection);
        },
        // eslint-disable-next-line
        [],
    );

    return {
        getClubsOverviewApi,
        getClubsOptionsApi,
        postClubsOverviewApi,
        getClubApi,
        postClubApi,
        putClubApi,
        postEnsureAccountsApi,
    };
};

export default useClubApi;
